<template>
  <div class="container"
       style>
    <!-- 主体内容 -->
    <Boyo-Content ref="BoyoContent"
                  :visible="filterInfo.visible"
                  style="height:97%">
      <!-- 表格内部按钮 -->
      <Boyo-Form :formInfo="formInfo"
                   :refObj.sync="formInfo.ref"
                   :listTypeInfo='listTypeInfo'
                   @formremoteMethod="formremoteMethod">
      </Boyo-Form>
      <div style="position:absolute;top:20px;right:40px;">
        <P>免冠图</P>
        <el-upload
            class="avatar-uploader"
            :action="action"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="handleAvatarSuccess">
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon">
          </i>
        </el-upload>
      </div>
      <div style="position:absolute;top:280px;right:60px;">
        <el-upload
          class="upload-demo"
          :action="action"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :limit="1"
          :on-exceed="handleExceed"
          :file-list="fileList">
          <el-button size="small" type="primary">上传入职图片</el-button>
        </el-upload>
      </div>
      <BoyoButton :buttonList="buttonList"
                  @handClick="handClick">
      </BoyoButton>
      <div>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="个人证书" name="1">
            <el-table :data="tableData"
                      border
                      style="width: 100%;margin-top:20px"
                      :header-cell-style="{background:'#eff3f8',color:'#3C3C3C',padding:'4px 0'}"
                      :cell-style="{padding:'2px'}"
                      @row-click="handleCellChange"
                      @cell-dblclick="TabDblclick">
                <el-table-column prop="certNumber"
                                label="序号"  width="60px">
                </el-table-column>
                <el-table-column prop="certName"
                                label="证书名称">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.certName"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="certTime"
                                label="获得证书时间">
                  <template slot-scope="scope">
                    <el-date-picker size="small" type="date" clearable v-model="scope.row.certTime"></el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column prop="certImage"
                                label="证书图片"
                                width='120px'>
                  <template slot-scope="scope">
                    <el-upload
                      class="avatar-uploader2"
                      :action="action"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccessHead2"
                      :before-upload="beforeAvatarUpload">
                      <img v-if="scope.row.certImage" :src="scope.row.certImage" style="height:40px;width:40px">
                      <i v-else class="el-icon-plus avatar-uploader-icon2">
                      </i>
                    </el-upload>
                  </template>
                </el-table-column>
                <el-table-column prop="remark"
                                label="备注">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.remark"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="180px">
                  <template slot-scope="scope">
                    <el-button @click.native.prevent="addRow(scope.row,tableData)"
                              type="primary"
                              size="mini">添加</el-button>
                    <el-button size="mini"
                              type="danger"
                              @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                  </template>
                </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="家庭情况" name="2">
            <el-table :data="tableData2"
                      border
                      style="width: 100%;margin-top:20px"
                      :header-cell-style="{background:'#eff3f8',color:'#3C3C3C',padding:'4px 0'}"
                      :cell-style="{padding:'2px'}">
                <el-table-column prop="guardian"
                                label="亲属名称">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.guardian"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="named"
                                label="称呼">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.named"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="birthDate"
                                label="出生年月">
                  <template slot-scope="scope">
                    <el-date-picker size="small" type="month" clearable v-model="scope.row.birthDate"></el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column prop="addressContact"
                                label="联系地址">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.addressContact"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="phoneContact"
                                label="联系电话">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.phoneContact"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="remark"
                                label="备注">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.remark"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="180px">
                  <template slot-scope="scope">
                    <el-button @click.native.prevent="addRow(scope.row,tableData2)"
                              type="primary"
                              size="mini">添加</el-button>
                    <el-button size="mini"
                              type="danger"
                              @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                  </template>
                </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="教育经历" name="3">
            <el-table :data="tableData3"
                      border
                      style="width: 100%;margin-top:20px"
                      :header-cell-style="{background:'#eff3f8',color:'#3C3C3C',padding:'4px 0'}"
                      :cell-style="{padding:'2px'}">
                <el-table-column prop="graduateSchool"
                                label="毕业院校">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.graduateSchool"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="specialities"
                                label="专业科系">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.specialities"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="schoolExp"
                                label="学历">
                  <template slot-scope="scope">
                    <!-- <el-input size="small"
                              v-model="scope.row.schoolExp"></el-input> -->
                    <el-select v-model="scope.row.schoolExp"
                    filterable clearable placeholder="请选择">
                      <el-option
                        v-for="item in listTypeInfo.education"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="graduateTime"
                                label="毕业时间">
                  <template slot-scope="scope">
                    <el-date-picker size="small" type="date" clearable v-model="scope.row.graduateTime"></el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column prop="remark"
                                label="备注">
                  <template slot-scope="scope">
                    <el-input size="small"
                              v-model="scope.row.remark"></el-input>
                  </template>
                </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="银行卡" name="4">
            <el-table :data="tableData4"
                      border
                      style="width: 100%;margin-top:20px"
                      :header-cell-style="{background:'#eff3f8',color:'#3C3C3C',padding:'4px 0'}"
                      :cell-style="{padding:'2px'}">
                <el-table-column prop="bankAccount"
                                label="卡号">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.bankAccount"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="bankName"
                                label="账户名称">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.bankName"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="openBank"
                                label="开户行">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.openBank"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="phone"
                                label="电话">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.phone"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="remark"
                                label="备注">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.remark"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="180px">
                  <template slot-scope="scope">
                    <el-button @click.native.prevent="addRow(scope.row,tableData4)"
                              type="primary"
                              size="mini">添加</el-button>
                    <el-button size="mini"
                              type="danger"
                              @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                  </template>
                </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="工作经历" name="5">
            <el-table :data="tableData5"
                      border
                      style="width: 100%;margin-top:20px"
                      :header-cell-style="{background:'#eff3f8',color:'#3C3C3C',padding:'4px 0'}"
                      :cell-style="{padding:'2px'}">
                <el-table-column prop="workCompany"
                                label="公司">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.workCompany"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="position"
                                label="职位">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.position"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="jobContent"
                                label="工作内容">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.jobContent"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="entryTime"
                                label="入职日期">
                  <template slot-scope="scope">
                    <el-date-picker size="small" type="date" clearable v-model="scope.row.entryTime"></el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column prop="leaveTime"
                                label="离职日期">
                  <template slot-scope="scope">
                    <el-date-picker size="small" type="date" clearable v-model="scope.row.leaveTime"></el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column prop="leavenReason"
                                label="离职原因">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.leavenReason"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="remark"
                                label="备注">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.remark"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="180px">
                  <template slot-scope="scope">
                    <el-button @click.native.prevent="addRow(scope.row,tableData5)"
                              type="primary"
                              size="mini">添加</el-button>
                    <el-button size="mini"
                              type="danger"
                              @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                  </template>
                </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
      <Boyo-Dialog :dialogInfo="dialogInfo"
                   @dialogEvent="dialogEvent">
          <el-avatar shape="square" :size="250" fit="cover" :src="imgUrl"></el-avatar>
      </Boyo-Dialog>
    </Boyo-Content>
  </div>
</template>

<script>
import BoyoContent from "@/components/BoyoContent";
import BoyoButton from "@/components/BoyoButton";
import BoyoTable from "@/components/BoyoTable";
import BoyoForm from "@/components/BoyoFormthree";
import BoyoDialog from '@/components/BoyoDialog'
import { excel } from '@/utils/excel'
import config from '@/api/config'
import { rule, validateTel, IDcard,validateSort } from '@/utils/rules'
import * as imageConversion from 'image-conversion'
export default {
  name: "StaffAdd",
  components: {
    BoyoContent,
    BoyoButton,
    BoyoForm,
    BoyoTable,
    BoyoDialog,
  },
  props: {},
  data () {
    let imgUrl = config.pingImgUrl
    return {
      fileList: [],//入职图片
      imageUrl: '',
      imgUrl,
      action:config.upload,
      search: {},
      add2:0,
      activeName: '1',
      tableData:[{employeeId:'',certName:'',certNumber:1,certTime:'',certImage:'',remark:''}],
      tableData2:[{employeeId:'',guardian:'',named:'',birthDate:'',addressContact:'',phoneContact:'',remark:''}],
      tableData3:[{employeeId:'',graduateSchool:'',specialities:'',schoolExp:'',graduateTime:'',remark:''}],
      tableData4:[{employeeId:'',employeeName:'',bankAccount:'',bankName:'',openBank:'',phone:'',remark:''}],
      tableData5:[{employeeId:'',entryTime:'',jobContent:'',leaveTime:'',leavenReason:'',position:'',workCompany:'',remark:''}],
      // 搜索相关
      filterInfo: {
        visible: null, // 是否显示
        data: {
          employeeName: '',
          deptId:'',
          pageNum:1,
          pageSize:100
        },
        list: [
          { type: "text", label: "员工名称：", value: "employeeName" },
          { type: "select", label: "部门：", value: "deptId",list:'deptId' }
        ]
      },
      // 下拉框相关信息
      listTypeInfo: {
        tFlag:[{value:1,label:'已审核'},{value:0,label:'未审核'}],
        deptId:[],//部门
        employeeId:[],//员工
        education: [{ value: '小学', label: '小学' }, { value: '初中', label: '初中' },
                   { value: '高中', label: '高中' }, { value: '专科', label: '专科' },
                   { value: '本科', label: '本科' }, { value: '研究生', label: '研究生' }, 
                   { value: '硕士', label: '硕士' }, { value: '博士', label: '博士' }, { value: '博士后', label: '博士后' }],
        postId:[],//职位
        ttype:[{value:0,label:'计时'},{value:1,label:'记件'}],
        gender:[{ value: '男', label: '男' }, { value: '女', label: '女' }],
        attendanceMark:[{ value: 0, label: '考勤' }, { value: 1, label: '不考勤' }],
        liveType:[{ value: 0, label: '公司宿舍' }, { value: 1, label: '司外自租' }],
        maritalStatus: [{value: 0, label: '未婚'}, {value: 1, label: '已婚'}],
        tissueId:[],//组织
      },
      // 表格头部按钮相关
      buttonList: {
        // 左按钮
        left: [
          // { icon: 'el-icon-download', style: 'background:#f8ac59', desc: '导出', event: 'excel' }
        ],
        right: []
      },
      // 弹框相关
      dialogInfo: {
        visible: false, // 弹框是否显示
        width: '400px', // 宽度
        switch: true, // 表单样式切换按钮
        title: {
          img1: '入职图片',
          img2: '个人证书图片',
        },
        type: 'img1', // 显示哪个标题
        // 按钮列表
        btList: [
          { label: '关闭', type: '', icon: '', event: 'close', loading: false }
        ]
      },
      // 员工表单相关
      formInfo: {
        ref: null,
        labelWidth: "30%",
        inline: true,
        data: {
          deptid: '',
          deptname:'',
          postid: '',
          postname:'',
          employeename: '',
          // employeeno: '',
          identityno: '',
          empaddress:'',
          mobilephone: '',
          entrydate:'',
          gender:'',
          maritalStatus:'',
          birthday:'2000-01-01 00:00:00',
          // ttype:'',
          // timingPrice:'',
          // entryPicture:'',
          positiveTime:'',
          nation:'',
          schoolExpName:'',
          stature:'',
          weight:'',
          coefficient:'',//奖金系数
          // attendanceMark:'',
          liveType:'',
          tflag:0,
          // tissueId:'',
          // tissueName:'',
          // createTissueId:'',
          // createTissueName:'',
        },
        list: [
          // { type: 'select使用组织：', label: '使用组织：', value: 'tissueId', style: 'width:95%', className: 'form_item_three',list:'tissueId',disabled:true},
          { type: 'select部门：', label: '部门：', value: 'deptid', style: 'width:95%', className: 'form_item_three',list:'deptId'},
          // { type: 'textNum', label: '员工编码：', value: 'employeeno', style: 'width:80%', className: 'form_item_three'},
          { type: 'text', label: '员工名称：', value: 'employeename', style: 'width:95%', className: 'form_item_three'},
          { type: 'select职位：', label: '职位：', value: 'postid', style: 'width:80%', className: 'form_item_three',list:'postId' },
          { type: 'text', label: '身份证号：', value: 'identityno', style: 'width:95%', className: 'form_item_three' },
          { type: 'select性别：', label: '性别：', value: 'gender', list: 'gender', style: 'width:95%', className: 'form_item_three' },
          { type: 'text', label: '电话：', value: 'mobilephone', style: 'width:80%', className: 'form_item_three' },
          { type: 'dateDay', label: '入职时间：', value: 'entrydate', style: 'width:95%',className: 'form_item_three'},
          { type: 'select婚姻状态：', label: '婚姻状态：', value: 'maritalStatus', list: 'maritalStatus', style: 'width:95%', className: 'form_item_three' },
          { type: 'dateDay', label: '转正日期：', value: 'positiveTime', style: 'width:80%',className: 'form_item_three'},
          { type: 'text', label: '地址：', value: 'empaddress', style: 'width:95%', className: 'form_item_three'},
          { type: 'date', label: '生日：', value: 'birthday', style: 'width:95%', className: 'form_item_three' },
          // { type: 'select考勤标志：', label: '考勤标志：', value: 'attendanceMark', list: 'attendanceMark', style: 'width:80%', className: 'form_item_three' },
          { type: 'select居住方式：', label: '居住方式：', value: 'liveType', list: 'liveType', style: 'width:80%', className: 'form_item_three' },
          { type: 'text', label: '民族：', value: 'nation', style: 'width:95%', className: 'form_item_three'},
          // { type: 'text', label: '学历：', value: 'schoolExpName', style: 'width:95%', className: 'form_item_three'},
          { type: 'select学历：', label: '学历：', value: 'schoolExpName', style: 'width:95%', className: 'form_item_three',list:'education'},
          { type: 'text', label: '身高：', value: 'stature', style: 'width:80%', className: 'form_item_three'},
          { type: 'text', label: '体重：', value: 'weight', style: 'width:95%', className: 'form_item_three'},
        ],
        rules: {
          // tissueId:[{ required: true, trigger: 'blur',message: '请选择组织' }],
          identityno:[{ required: true, trigger: 'blur',validator: IDcard }],
          deptid:[{ required: true, trigger: 'blur',message: '请选择部门' }],
          employeename:[{ required: true, trigger: 'blur',message: '请输入员工名称' }],
          postid:[{ required: true, trigger: 'blur',message: '请选择职位' }],
          gender:[{ required: true, trigger: 'blur',message: '请选择' }],
          mobilephone:[{ required: true, trigger: 'blur',validator: validateTel}],
          // coefficient:[{ required: true, trigger: 'blur',message: '请输入奖金系数' }],
          entrydate:[{ required: true, trigger: 'blur',message: '请选择入职时间' }],
          // ttype:[{ required: true, trigger: 'blur',message: '请选择记价方式' }],
        }
      }
    };
  },
  created () {
    const leftBtn = this.buttonList.left
    leftBtn.push({ icon: "el-icon-back", style: "background:#fff;color:#666;border:1px solid #666;margin-right:15px", desc: "返回", event: "back" })
    leftBtn.push({ icon: "el-icon-check", style: "background:#1a7bb9", desc: "保存", event: "create" })
  },
  mounted () {
    this.init();
    this.$api.department.getBaseDeptPage({pageNum: 1, pageSize: 999}).then(res => {//部门
        if(res.code == 0) {
            this.listTypeInfo.deptId = []
            let list1 = res.data.list
            for( let i in list1 ) {
                this.listTypeInfo.deptId.push({value: list1[i].id, label: list1[i].deptname,tissueId:list1[i].tissueId,tissueName:list1[i].tissueName})
            }
        }
    })
    this.$api.position.getBaseOfficePostPage({pageNum: 1, pageSize: 999}).then(res => {//职位
        if(res.code == 0) {
            this.listTypeInfo.postId = []
            let list2 = res.data.list
            for( let i in list2 ) {
                this.listTypeInfo.postId.push({value: list2[i].id, label: list2[i].postName})
            }
        }
    })
    this.$api.staff.getBaseSchoolingExpPage({pageNum:1,pageSize:99,tFlag: 1}).then(res => {//学历列表
      if(res.code == 0) {
        this.listTypeInfo.education = []
        for( let f of res.data.list) {
          this.listTypeInfo.education.push({value:f.expName,label:f.expName})
        }
      }
    })
  },
  methods: {
    // 初始化
    init () {
      Object.assign(this.formInfo.rules, rule(this.formInfo.list));
    },
    handleClick(tab, event) {//标签点击事件
      // console.log(tab.name,tab.label);
    },
    addRow (index, rows) {
      //判断标签 添加到哪个表格
      let bb = {}
      if (this.activeName == '1') {
        bb = {employeeId:'',certName:'',certNumber:this.tableData.length+1,certTime:'',certImage:'',remark:'',addIndex:0}
      } else if (this.activeName == '2') {
        bb = {employeeId:'',guardian:'',named:'',birthDate:'',addressContact:'',phoneContact:'',remark:''}
      } else if (this.activeName == '3') {
        bb = {employeeId:'',graduateSchool:'',specialities:'',schoolExp:'',graduateTime:'',remark:''}
      } else if (this.activeName == '4') {
        bb = {employeeId:'',employeeName:'',bankAccount:'',bankName:'',openBank:'',phone:'',remark:''}
      } else if (this.activeName == '5') {
        bb = {employeeId:'',entryTime:'',jobContent:'',leaveTime:'',leavenReason:'',position:'',workCompany:'',remark:''}
      }
      rows.push(bb)
      for (let d in rows) {
        rows[d].addIndex = d
      }
    },
    handleDelete (index, rows) {
      //判断标签进行删除的模块
      switch (this.activeName) {
        case '1':
          if (this.tableData.length>1) {
            this.tableData.splice(index, 1);
            for (let i in this.tableData) {
              this.tableData[i].certNumber = Number(i) + 1
              this.tableData[i].addIndex = Number(i)
            }
          }
          break
        case '2':
          if (this.tableData2.length>1) {
            this.tableData2.splice(index, 1);
          }
          break
        case '3':
          if (this.tableData3.length>1) {
            this.tableData3.splice(index, 1);
          }
          break
        case '4':
          if (this.tableData4.length>1) {
            this.tableData4.splice(index, 1);
          }
          break
        case '5':
          if (this.tableData5.length>1) {
            this.tableData5.splice(index, 1);
          }
          break
      }
    },
    beforeAvatarUpload (file) {
      return new Promise((resolve, reject) => {
        let isLt2M2 = file.size / 1024 / 1024 < 0.2 // 判定图片大小是否大于100Kb
        if (isLt2M2) {
          resolve(file)
        }
        imageConversion.compressAccurately(file, 200).then(res => {
          // console.log(res)
          resolve(res)
        })
      })
    },
    handleCellChange (row, column, event) {//行点击事件
      // console.log(row, column, event)
      this.add2 = Number(row.certNumber) -1;
    },
    TabDblclick(row, column, cell, event){//表格双击事件
      if (column.label == '证书图片') {
        if (row.certImage) {
          this.imgUrl = row.certImage
          this.dialogInfo.type = 'img2'
          this.dialogInfo.visible = true
        }
      }
    },
    handleAvatarSuccessHead2(res, file) {
      // console.log(res, file,this.add2)
      this.tableData[Number(this.add2)].certImage = res.data
    },
    handleAvatarSuccess(res, file) {//图片上传成功
      // console.log(res, file)
      this.imageUrl = res.data
    },
    handleRemove(file, fileList) {//图片移除
      this.imgUrl=''
    },
    handlePreview(file) {//点击上传的图片
      // console.log(file);
      this.imgUrl=file.response.data
      this.dialogInfo.type = 'img1'
      this.dialogInfo.visible = true
    },
    handleExceed(files, fileList) {//限制上传数量的钩子
      // console.log(files, fileList)
      this.$message({ message: '只能上传一张', type: 'warning' })
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    formremoteMethod (data, query, type) {
      switch (type) {
        case 'select计价方式：':
          if (this.formInfo.data.ttype == 0) {
            this.formInfo.data.timingPrice = 0
            this.formInfo.list[10].disabled = false
            this.formInfo.list[11].disabled = true
          }else{
            this.formInfo.data.coefficient = 0
            this.formInfo.list[10].disabled = true
            this.formInfo.list[11].disabled = false
          }
          break
        case 'select使用组织：':
          this.$api.department.getBaseDeptPage({pageNum: 1, pageSize: 999,tissueId:this.formInfo.data.tissueId}).then(res => {//部门
              if(res.code == 0) {
                  this.listTypeInfo.deptId = []
                  let list1 = res.data.list
                  for( let i in list1 ) {
                      this.listTypeInfo.deptId.push({value: list1[i].id, label: list1[i].deptname,tissueId:list1[i].tissueId,tissueName:list1[i].tissueName})
                  }
              }
          })
          this.formInfo.data.deptid = ''
          break
      }
    },
    // 表格头部按钮相关事件
    handClick (event, data) {
      const formInfo = this.formInfo;
      switch (event) {
        case "create":
          formInfo.ref.validate((val) => {//调保存接口前先校验必传项是否为空
            if (val) {
              // if(formInfo.data.ttype == 0){
              //   if (!formInfo.data.coefficient) {
              //     this.$message({message: '计价方式为记时，需填写奖金系数', type: 'warning'})
              //     return
              //   }
              // }else{
              //   if (!formInfo.data.timingPrice) {
              //     this.$message({message: '计价方式为记件，需填写计件单价', type: 'warning'})
              //     return
              //   }
              // }
              formInfo.data.entryPicture = this.imgUrl
              formInfo.data.headPhoto = this.imageUrl
              for (let ind of this.listTypeInfo.deptId) {
                if (formInfo.data.deptid == ind.value) {
                  formInfo.data.deptname = ind.label
                }
              }
              formInfo.data.postname = ''
              for (let ind2 of this.listTypeInfo.postId) {
                if (formInfo.data.postid == ind2.value) {
                  formInfo.data.postname = ind2.label
                }
              }
              this.$api.staff.saveBaseEmployee(formInfo.data).then(res => {//员工保存
                if (res.code === 0) {
                  this.$message({ message: res.msg, type: 'success' })
                  let employeeId = res.data.id
                  let employeeName = res.data.employeename
                  for (let index of this.tableData) {
                    index.employeeId = employeeId
                  }
                  this.$api.staff.saveBaseEmployeeCert({employeeCertSaveFormList:this.tableData}).then(res => {//员工证件保存
                  })
                  for (let index2 of this.tableData2) {
                    index2.employeeId = employeeId
                  }
                  this.$api.staff.saveBaseEmployeeFamily({employeeFamilySaveFormList:this.tableData2}).then(res => {//员工家庭情况保存
                  })
                  this.tableData3[0].employeeId = employeeId
                  this.$api.staff.saveBaseEmployeeEducation({employeeEducationSaveFormList:this.tableData3}).then(res => {//员工教育经历保存
                  })
                  for (let index4 of this.tableData4) {
                    index4.employeeId = employeeId
                    index4.employeeName = employeeName
                  }
                  this.$api.staff.saveBaseEmployeeBank({employeeBankSaveFormList:this.tableData4}).then(res => {//银行卡保存
                  })
                  for (let index5 of this.tableData5) {
                    index5.employeeId = employeeId
                  }
                  if (this.tableData5[0].workCompany) {
                    this.$api.staff.saveBaseEmployeeWork({employeeWorkSaveFormList:this.tableData5}).then(res => {//工作经历保存
                    })
                  }
                  this.$nextTick(() => {
                    this.$router.push('/index/system/Staff')
                  })
                } else {
                  this.$message({ message: res.msg, type: 'error' })
                }
              })
            }
            // for (let i in this.tableData) {
            //   if (!this.tableData[i].certName) {
            //     this.$message({ message: '证件模块中证书名称不能为空', type: 'warning' })
            //     return
            //   }
            // }
            // for (let j in this.tableData2) {
            //   if (!this.tableData2[j].guardian || !this.tableData2[j].named || !this.tableData2[j].phoneContact) {
            //     this.$message({ message: '家庭情况模块中亲属名称、称呼和联系电话不能为空', type: 'warning' })
            //     return
            //   }
            // }
            // if (!this.tableData3[0].graduateSchool || !this.tableData3[0].specialities || !this.tableData3[0].schoolExp) {
            //   this.$message({ message: '毕业院校、专业科系和学历不能为空', type: 'warning' })
            //   return
            // }
            // for (let k in this.tableData4) {
            //   if (!this.tableData4[k].bankAccount || !this.tableData4[k].bankName || !this.tableData4[k].openBank || !this.tableData4[k].phone) {
            //     this.$message({ message: '银行卡模块中账户名称、员工名称、开户行以及电话不能为空', type: 'warning' })
            //     return
            //   }else{
            //     let strBin = '10,18,30,35,37,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,58,60,62,65,68,69,84,87,88,94,95,98,99'
            //     if (this.tableData4[k].bankAccount.trim().length < 12 || this.tableData4[k].bankAccount.trim().length > 19) {
            //       this.$message({ message: '银行卡号长度必须在12到19之间', type: 'warning' })
            //       return
            //     }
            //     if (strBin.indexOf(this.tableData4[k].bankAccount.substring(0, 2)) === -1) {
            //       this.$message({ message: '银行卡号不符合规范', type: 'warning' })
            //       return
            //     }
            //   }
            // }
            // for (let z in this.tableData5) {
            //   if (!this.tableData5[z].workCompany || !this.tableData5[z].jobContent) {
            //     this.$message({ message: '工作经历模块中公司、工作内容不能为空', type: 'warning' })
            //     return
            //   }
            // }
          })
          break;
        case "back":
          this.$router.push('/index/system/Staff')//返回员工管理界面
          break;
      }
    },
    // 对话框按钮事件
    dialogEvent (event) {
      const dialogInfo = this.dialogInfo
      switch (event) {
        case 'close':
          dialogInfo.visible = false
          break
      }
    },
  }
};
</script>
<style lang="stylus" scoped>
.avatar-uploader>>> .el-upload
  border 1px dashed #d9d9d9
  border-radius 6px
  cursor pointer
  position relative
  overflow hidden
.avatar-uploader>>> .el-upload:hover
  border-color #409EFF
.avatar-uploader2
  border-style dashed
  border-color #d9d9d9
  border-width 1px
  // border-radius 6px
  width 40px
  height 40px
  cursor pointer
  position relative
  overflow hidden
  align center
.avatar-uploader-icon
  font-size 28px
  color #8c939d
  width 150px
  height 200px
  line-height 200px
  text-align center
.avatar-uploader-icon2
  font-size 20px
  color #8c939d
  width 40px
  height 40px
  line-height 40px
  text-align center
.avatar
  width 150px
  height 200px
  display block
.uploadTip
  font-size 15px
</style>



// WEBPACK FOOTER //
// src/views/pages/System/StaffAdd.vue